import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp, faPencil } from '@fortawesome/free-solid-svg-icons';
import './pages-css/IsecProjectTable.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setProjects } from '../../REDUX_ISECURION/projectList/projectlistAction';
import { useAuth } from '../../Context/UserContext';
import IsecNavbar2 from './IsecNavbar2';
import IsecNavbar from './IsecNavbar';
import { toast } from 'react-toastify';
import { Icon } from '@iconify/react';
import { url } from '../../constants/url';
import ClientNavbar1 from '../../Client-components/Pages/ClientNavbar1';
import GroupBy from '../Modal/GroupBy';
import AddProject from '../Modal/AddProject';



const IsecProjectTable = () => {
  const projects = useSelector((state) => state.projectlist.projects);
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState('');
  const [inputFocused, setInputFocused] = useState(false);
  const history = useNavigate('');
  const location = useLocation();

  const [suggestions, setSuggestions] = useState([])
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  const initialFilter = location.state?.filter || 'All';
  const [selectedProjectFilter, setSelectedProjectFilter] = useState(initialFilter);

  const [currentPage, setCurrentPage] = useState(1);
  const [openNewProject, setOpenNewProject] = useState(false)


  const newProjectRef = useRef(null);
  const suggestionsRef = useRef(null);

  const dropdownRef = useRef(null);

  const options = [25, 50, 75, 100];

  const [openDropDown, setOpenDropDown] = useState(false)

  const [projectsPerPage, setProjectsPerPage] = useState(25);

  const specialChars = /[0-9][!@#$%^&*(),.?":{}|<>]/;

  const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const { userRole, logout, emailVer, isSidebarCollapsed } = useAuth()

  const childRef = useRef();


  const handleAddNewProject = () => {
    setOpenNewProject(true)
  }

  const handleSelect = (value) => {
    setProjectsPerPage(value);
    setOpenDropDown(false);
    setCurrentPage(1);
  };

  const fetchEmployeeName = async () => {
    try {
      const response = await fetch(`${url}/fetchemployeedetails`, {
        method: "GET",
        credentials: 'include'
      })
      const employeeData = await response.json()
      setSuggestions(employeeData)
      if (response.status === 440) {
        logout()
        toast.error("User logout due to inactivity", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }
    } catch (error) {
      console.log(error)
    }
  }

  // Refer project.js file for backend code
  const fetchProjectDetails = async () => {
    try {
      const response = await fetch(`${url}/fetchprojectlist`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include'
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      if (response.status === 440) {
        logout()
        toast.error("User logout due to inactivity", {
          position: 'top-right',
          autoClose: 2500,
          pauseOnHover: false,
        });
        return
      }

      const projectList = await response.json();
      if (!Array.isArray(projectList)) {
        throw new Error("Expected an array of registerData")
      }
      const sortedProject = projectList.sort((a, b) => {
        const statusOrder = ['inprogress', 'retesting', 'completed'];
        const statusA = a.status.toLowerCase();
        const statusB = b.status.toLowerCase();
        return statusOrder.indexOf(statusA) - statusOrder.indexOf(statusB);
      });

      dispatch(setProjects(sortedProject));
    } catch (error) {
      console.error("Failed to fetch project details:", error);
    }
  };


  useEffect(() => {
    fetchProjectDetails()

  }, [])

  const handleSearchInput = (event) => {
    setSearchQuery(event.target.value);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < getTotalPages()) {
      setCurrentPage(currentPage + 1);
    }
  };

  const getTotalPages = () => {
    return Math.ceil((filteredProjects ?? []).length / projectsPerPage);
  };

  const startIndex = (currentPage - 1) * projectsPerPage;
  const endIndex = startIndex + projectsPerPage;

  const getPageProjects = () => {
    if (!filteredProjects) {
      return [];
    }
    const slicedProjects = filteredProjects.slice(startIndex, endIndex);
    return slicedProjects.map((project, index) => ({
      ...project,
      slNo: startIndex + index + 1,
    }));
  };

  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', options);
  };

  const getStatus = (status) => {
    if (status === 'Inprogress') {
      return 'congoing';
    } else if (status === 'Retesting') {
      return 'cretesting';
    } else if (status === 'Completed') {
      return 'ccompleted';
    }
    return '';
  };

  const getType = (clientType) => {
    switch (clientType) {
      case 'Commercial':
        return 'commercial';
      case 'Government':
        return 'government';
      case 'Commercial CertIn':
        return 'commercial_certin';
      default:
        return '';
    }
  };

  const filteredProjects = projects.filter((project) => {
    const matchesSearch =
      project.projectName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      project.clientName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      project.applicationType.toLowerCase().includes(searchQuery.toLowerCase()) ||
      project.status.toLowerCase().includes(searchQuery.toLowerCase()) ||
      project.projectType.toLowerCase().includes(searchQuery.toLowerCase());


    const matchesFilter =
      selectedProjectFilter === 'All' ||
      project.status === selectedProjectFilter;

    return matchesSearch && matchesFilter;
  });

  useEffect(() => {
    fetchEmployeeName()
    if (!emailVer.endsWith('@isecurion.com')) {
      logout();
      return;
    }
  }, []);

  const handleClickOutside = (event) => {
    if (
      suggestionsRef.current &&
      !suggestionsRef.current.contains(event.target) &&
      newProjectRef.current &&
      !newProjectRef.current.contains(event.target)
    ) {
      setFilteredSuggestions([]);
    }
  };

  useEffect(() => {
    if (openNewProject) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openNewProject])



  const statuses = ['All', 'Inprogress', 'Retesting', 'Completed'];


  const filteredStatuses = statuses.filter((status) => status !== selectedProjectFilter);


  const getRandomColor = (text) => {
    const colors = [
      '#FF5733', '#33c5ff', '#5733FF', '#FF33A8', '#2E89E4',
      '#2680c5', '#d01717', '#b14d00', '#1e6461',
    ];
    const hash = [...text].reduce((acc, char) => acc + char.charCodeAt(0), 0)
    return colors[hash % colors.length]
  }

  return (
    <div className='table-list-dash'>
      <div>
        <div className='client_navabr1'>
          <ClientNavbar1 />
        </div>
        <div className='isecurion_navbar_second'><IsecNavbar2 /></div>
      </div>

      <div className='wrap_isecurion_navbar_dashboard'>
        <div className={isSidebarCollapsed ? 'isecuriondash-navbar' : 'isecuriondash_close_navbar'}>
          <IsecNavbar />
        </div>

        <div className={isSidebarCollapsed ? 'wrap_isecurion_dashboard_data_open' : 'wrap_isecurion_dashboard_data'}>
          <div className="isecurion_project_container">
            <div className="isecurion_project_heading">
              View and manage all ongoing and completed penetration testing projects
            </div>

            {/* isecurion project search and filter */}
            <div className="isecurion_project_search_filter_container">
              <div className="isecurion_project_search_container">
                <Icon
                  icon="ic:round-search"
                  width="24"
                  height="24"
                  color="#E76A34"
                />

                <input
                  className="isecurion_project_search_input"
                  type="text"
                  placeholder='Search by client, project name, application'
                  onChange={handleSearchInput}
                  value={searchQuery}
                  data-testid="search-input"
                  onFocus={() => setInputFocused(true)}
                  onBlur={() => setInputFocused(false)}
                />
              </div>
              <div style={{ display: 'flex' }}>


                <GroupBy
                  selectedProjectFilter={selectedProjectFilter}
                  setSelectedProjectFilter={setSelectedProjectFilter}
                  filteredStatuses={filteredStatuses} />

                {userRole === 'manager' && (
                  <div className='new_project_button'>
                    <button
                      onClick={() => handleAddNewProject(true)}>
                      <span style={{ marginRight: "10px" }}>
                      </span>
                      New Project
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="project-pagination_table">
              <div className="project-wrap-pagination-data">
                <div className="table_size">
                  <div className="wrap_dropdown_project_table" ref={dropdownRef}>
                    <button
                      onClick={() => setOpenDropDown(!openDropDown)}
                      className="dropdown-toggle"
                    >
                      {projectsPerPage}{" "}
                      {openDropDown ? (
                        <span style={{ fontSize: "14px", marginLeft: "5px" }}>
                          <FontAwesomeIcon icon={faCaretUp} />
                        </span>
                      ) : (
                        <span style={{ fontSize: "14px", marginLeft: "5px" }}>
                          <FontAwesomeIcon icon={faCaretDown} />
                        </span>
                      )}
                    </button>

                    {openDropDown && (
                      <div className="dropdown-menu-project-list">
                        <ul>
                          {options.map((option) => (
                            <li key={option} onClick={() => handleSelect(option)}>
                              {option}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>

                  {filteredProjects.length === 0 ? (
                    ""
                  ) : (
                    <p>
                      {startIndex + 1} to{" "}
                      {Math.min(endIndex, filteredProjects.length)} of{" "}
                      {filteredProjects.length}
                    </p>
                  )}

                  {filteredProjects && (
                    <div className="wrap-pages_client">
                      <button
                        data-testid="previous_page"
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1 || getTotalPages() === 1 || filteredProjects.length === 0}
                      >
                        <Icon icon="ep:arrow-left-bold" width="18" height="18" />
                      </button>

                      <p data-testid="current_clientpage">{currentPage}</p>

                      <button
                        data-testid="next_page"
                        onClick={handleNextPage}
                        disabled={currentPage === getTotalPages() || getTotalPages() === 1 || filteredProjects.length === 0}>
                        <Icon icon="ep:arrow-right-bold" width="18" height="18" />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="isecurion_project_table_container">
              <table>
                <thead>
                  <tr>
                    <th>Sl No</th>
                    <th>Client Name</th>
                    <th>Project Name</th>
                    <th>
                      <span className="isecurion_project_table_header">
                        <Icon
                          icon="fluent-mdl2:open-folder-horizontal"
                          width="16"
                          height="16"
                        />
                        <span>Application type</span>
                      </span>
                    </th>

                    <th>
                      <span className="isecurion_project_table_header">
                        <Icon
                          icon="octicon:briefcase-24"
                          width="16"
                          height="16"
                          color="black"
                        />
                        <span>Client Type</span>
                      </span>
                    </th>

                    {userRole === 'manager' ? (
                      <th>
                        <span className="isecurion_project_table_header">
                          <Icon
                            icon="proicons:person"
                            width="16"
                            height="16"
                            color="black"
                          />
                          <span>Project Lead</span>
                        </span>
                      </th>
                    ) : ""}
                    <th>
                      <span className="isecurion_project_table_header">
                        <Icon
                          icon="fluent:phone-status-bar-20-regular"
                          width="20"
                          height="20"
                          color="#000000"
                        />
                        <span>Status</span>
                      </span>
                    </th>
                    {userRole === 'manager' && (
                      <th>
                        <span className="isecurion_project_table_header">
                          <span>Action</span>
                        </span>
                      </th>
                    )}

                  </tr>
                </thead>
                <tbody>
                  {filteredProjects.length === 0 ? (
                    <tr className='collapsetable' >
                      <td colSpan='9'>Projects not found....</td>
                    </tr>
                  ) : (
                    getPageProjects().map((project, index) => (
                      <>
                        <tr key={index}>
                          <td onClick={() => history(`/projects/status/${project._id}`)} >{index + 1}</td>
                          <td onClick={() => history(`/projects/status/${project._id}`)} >{project.clientName}</td>
                          <td onClick={() => history(`/projects/status/${project._id}`)} >{project.projectName}</td>
                          <td onClick={() => history(`/projects/status/${project._id}`)}>
                            {{
                              'Internal Network Penetration Testing': 'Internal Network PT',
                              'External Network Penetration Testing': 'External Network PT',
                            }[project.applicationType] || project.applicationType}
                          </td>

                          <td onClick={() => history(`/projects/status/${project._id}`)} >
                            <span className={`${getType(project.clientType)} client-type-pill`}>{{
                              'Commercial CertIn': 'Comm-CertIn'
                            }[project.clientType] || project.clientType}</span>
                          </td>
                          {userRole === 'manager' ? (
                            <td onClick={() => history(`/projects/status/${project._id}`)} >{project.teamLead ? (
                              <span
                                style={{ backgroundColor: getRandomColor(project.teamLead) }}
                                className="lead_name_initial">
                                {project.teamLead.charAt(0).toUpperCase()}
                              </span>
                            ) : ''}
                              {project.teamLead || "Unassigned"}</td>
                          ) : ""}
                          <td className="isecurion_project_table_status_cell" onClick={() => history(`/projects/status/${project._id}`)} >
                            <span className={getStatus(project.status)}>
                              {project.status}
                            </span>
                          </td>
                          {userRole === 'manager' && (
                            <td style={{ textAlign: 'center', fontSize: '18px', paddingLeft: '1px' }}>
                              <span
                                onClick={() => {
                                  if (childRef.current) {
                                    childRef.current.handleEdit(project._id);
                                  }
                                }}
                                style={{ color: '#2E89E4', cursor: 'pointer' }}
                              >
                                <FontAwesomeIcon icon={faPencil} />
                              </span>

                            </td>
                          )}

                        </tr>
                      </>
                    ))
                  )}

                </tbody>
              </table>
            </div>

          </div>

          <AddProject
            capitalizeFirstLetter={capitalizeFirstLetter}
            validateEmail={validateEmail}
            specialChars={specialChars}
            fetchProjectDetails={fetchProjectDetails}
            openNewProject={openNewProject}
            setOpenNewProject={setOpenNewProject}
            newProjectRef={newProjectRef}
            suggestionsRef={suggestionsRef}
            suggestions={suggestions}
            setSuggestions={setSuggestions}
            filteredSuggestions={filteredSuggestions}
            setFilteredSuggestions={setFilteredSuggestions}
            ref={childRef}
          />
        </div>
      </div>
    </div >
  );
};

export default IsecProjectTable;